import { styled, DialogTitle, Typography, DialogActions as DialogActions$1, paperClasses } from "@mui/material";
import { DialogContent as DialogContent$1, ModalDialog } from "../../utils/shared/Modal.js";
import "../submit-button/submit-button.js";
import "react/jsx-runtime";
import "../../../../../components/loader/loader.js";
import "../../../../../components/loader/data.js";
import "../../../../../components/animation/animation.js";
import "lottie-react";
import "../../../../../components/loader/loader.styles.js";
import "../../utils/shared/Button.js";
import "../submit-button/submit-button.styles.js";
import "@mui/system";
const Title = styled(DialogTitle)({
  fontSize: 17,
  lineHeight: "22.1px",
  letterSpacing: 0.15,
  textAlign: "center",
  margin: "0 auto",
  paddingBottom: 0
});
const Description = styled(Typography)({
  fontSize: 13,
  lineHeight: "16.9px",
  letterSpacing: 0.4,
  textAlign: "center",
  margin: "0 auto",
  paddingLeft: 0,
  paddingRight: 0
});
const DialogActions = styled(DialogActions$1)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0
});
const DialogContent = styled(DialogContent$1)({
  paddingBottom: 0,
  marginTop: 24,
  marginBottom: 36
});
const Dialog = styled(ModalDialog)({
  [`.${paperClasses.root}`]: {
    padding: "36px 28px"
  }
});
export {
  Description,
  Dialog,
  DialogActions,
  DialogContent,
  Title
};
